export enum MarketType {
    TWO_WAY_MATCH_ODDS = '_2_WAY_MATCH_ODDS',
    THREE_WAY_MATCH_ODDS = '_3_WAY_MATCH_ODDS',
    INNING_RUNS = 'INNING_RUNS',
    NEXT_BALL = 'NEXT_BALL',
    TOSS = 'TOSS',
    TEAM_4S = 'TEAM_4S',
    TEAM_6S = 'TEAM_6S',
    TOTAL_4S = 'TOTAL_4S',
    TOTAL_6S = 'TOTAL_6S',
    MATCH_TOTAL_RUNS = 'MATCH_TOTAL_RUNS',
    MATCH_TOTAL_WICKETS = 'MATCH_TOTAL_WICKETS',
    TEAM_ODD_EVEN = 'TEAM_ODD_EVEN',
    MATCH_ODD_EVEN = 'MATCH_ODD_EVEN',

    // Table Tennis
    TT_MATCH_WINNER = 'TT_MATCH_WINNER',
    TT_MATCH_TOTAL_ODD_EVEN = 'TT_MATCH_TOTAL_ODD_EVEN',
    TT_SET_WINNER = 'TT_SET_WINNER',
    TT_MATCH_SETS_HANDICAP = 'TT_MATCH_SETS_HANDICAP',
    TT_RACE_TO_N = 'TT_RACE_TO_N',
    TT_SET_POINTS_HANDICAP = 'TT_SET_POINTS_HANDICAP',
    TT_SET_TOTAL_POINTS = 'TT_SET_TOTAL_POINTS',
    TT_MATCH_TOTAL_POINTS = 'TT_MATCH_TOTAL_POINTS',
    TT_SET_TOTAL_ODD_EVEN = 'TT_SET_TOTAL_ODD_EVEN',
    TT_MATCH_CORRECT_SCORE = 'TT_MATCH_CORRECT_SCORE',
    TT_SET_POINT_N_WINNER = 'TT_SET_POINT_N_WINNER',
    TENNIS_MATCH_WINNER = 'TENNIS_MATCH_WINNER',
    TENNIS_MATCH_TOTAL_ODD_EVEN = 'TENNIS_MATCH_TOTAL_ODD_EVEN',
    TENNIS_MATCH_TOTAL_GAMES = 'TENNIS_MATCH_TOTAL_GAMES',
    TENNIS_MATCH_GAMES_HANDICAP = 'TENNIS_MATCH_GAMES_HANDICAP',
    TENNIS_MATCH_RACE_TO_N = 'TENNIS_MATCH_RACE_TO_N',
    TENNIS_SET_GAME_WINNER = 'TENNIS_SET_GAME_WINNER',

    /** A market type the backend offers and this frontend has no mapping for; shown as its raw name. */
    UNKNOWN = 'UNKNOWN'
}

export enum MarketOutcome {
    FINISHED = 'FINISHED',
    VOIDED = 'VOIDED'
}

export enum MarketStatus {
    OPEN = 'OPEN',
    SUSPENDED = 'SUSPENDED',
    CLOSED = 'CLOSED'
}

export enum SelectionStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    SUSPENDED = 'SUSPENDED'
}

export enum SelectionOutcome {
    WIN = 'WIN',
    LOSE = 'LOSE',
    VOID = 'VOID'
}

export enum Side {
    BACK = 'BACK',
    LAY = 'LAY',
    OVER = 'OVER',
    UNDER = 'UNDER'
}

export interface Price {
    id: number;
    externalId?: string;
    side: Side;
    price: number;
    probability?: number;
    outcomeValue?: number;
    selectionId: number;
    createdAt: string;
    updatedAt: string;
    priceChange?: 'up' | 'down' | null; // Track if price went up, down, or no change
}

export interface Selection {
    id: number;
    externalId: string;
    prices: Price[];
    name: string;
    reference?: string;
    status: SelectionStatus;
    outcome?: SelectionOutcome;
    marketId: number;
    createdAt: string;
    updatedAt: string;
}

export interface ProbabilityHistory {
    /** Null for a market type whose handler records no probabilities. */
    probabilities: string | null;
    createdAt: string;
}

export interface Market {
    id: number;
    eventId: number;
    name: string;
    marketType: MarketType;
    timestamp: number;
    marketStatus: MarketStatus;
    marketOutcome?: MarketOutcome;
    reference?: string;
    selections: Selection[];
    createdAt: string;
    updatedAt: string;
    closedAt: string;
    metadata?: {
        competitorIndex: number;
    };
    probabilitiesHistory?: ProbabilityHistory[];
    gr8MarketId?: number;
    gr8PeriodId?: number;
}
